import styled from 'styled-components'

export const CategoryActionsContainer = styled.div`
  position: absolute;
  top: 12px;
  right: 0;
`
